/**
 * File: src/services/newsletter-service.js
 * Mô tả: Dịch vụ đăng ký nhận tin tức game mới (Newsletter), xử lý gửi email và bắt lỗi.
 * Liên quan: src/components/newsletter-form.js
 */

/**
 * Kiểm tra định dạng email hợp lệ
 * @param {string} email 
 * @returns {boolean}
 */
const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
};

/**
 * Đăng ký tin tức mới với email
 * @param {string} email 
 * @returns {Promise<{success: boolean, message: string}>}
 */
export const subscribeNewsletter = async (email) => {
  try {
    if (!email || !isValidEmail(email)) {
      return {
        success: false,
        message: 'Địa chỉ email không hợp lệ. Vui lòng kiểm tra lại.',
      };
    }

    const endpoint = import.meta.env?.VITE_NEWSLETTER_ENDPOINT;
    if (!endpoint || endpoint === 'https://api.sntgames.com/newsletter') {
      throw new Error('Newsletter chưa được cấu hình.');
    }
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email.trim() }),
    });
    const result = await response.json();
    if (!response.ok || result.success !== true) {
      throw new Error('Dịch vụ chưa xác nhận nhận đăng ký.');
    }

    return {
      success: true,
      message: 'Cảm ơn bạn đã đăng ký! Chúng tôi sẽ gửi thông báo game mới nhất tới bạn.',
    };
  } catch (error) {
    console.error('Lỗi khi đăng ký newsletter:', error);
    return {
      success: false,
      message: 'Có lỗi xảy ra khi kết nối hệ thống. Vui lòng thử lại sau.',
    };
  }
};
